import { $axios, dealWithErrors, dealWithSuccess } from '../import/http'
import store from '@/store'
import filter from '../import/filter'
import moment from 'moment'

const statuses = [{
  status: 'CCD',
  text: 'storno',
  color: 'red',
}, {
  status: 'RCD',
  text: 'přijatá',
  color: 'blue',
}, {
  status: 'PIG',
  text: 'vyřizuje se',
  color: 'purple',
}, {
  status: 'SET',
  text: 'odeslaná',
  color: 'orange',
}, {
  status: 'CPD',
  text: 'vyřízená',
  color: 'green',
}]

const filteredKeys = [
  {
    path: '',
    loop: false,
    keys: [
      {
        key: 'odr_id',
        type: 'int',
      },
      {
        key: 'created_at',
        type: 'date',
      },
      {
        key: 'customer',
        type: 'string',
      },
      {
        key: 'is_company',
        type: 'bool',
      },
      {
        key: 'status',
        type: 'string',
        hashArray: statuses,
      },
      {
        key: 'ahe_telephone_number',
        type: 'string',
      },
      {
        key: 'order_total_vat',
        type: 'int',
      },
      {
        key: 'phe_name',
        type: 'string',
      },
    ],
  },
]

export default {
  namespaced: true,
  state: {
    items: [],
    detail: null,
    statuses: statuses,
  },
  mutations: {
    SET_ITEMS(state, items) {
      state.items = items
    },
    SET_CURRENT(state, items) {
      state.items = items.data
    },
    SET_CURRENT_DETAIL(state, item) {
      state.detail = item
    },
    ADD_NOTE(state, { id, item }) {
      item.created_at = moment()
      item.updated_at = moment()
      item.uer_id = store.getters['auth/getItem'].uer_id
      item.one_id = id
      state.detail.notes.push(item)
    },
    UPDATE_NOTE(state, { id, item }) {
      item.updated_at = moment()
      item.uer_id = store.getters['auth/getItem'].uer_id
      const oldNote = state.detail.notes.find(x => x.one_id === id)
      Object.assign(oldNote, item)
    },
    UPDATE_DELIVERY_PAYMENT(state, data) {
      if (data.payment_total) {
        state.detail.order_info.payment_total = data.payment_total
      }
      if (data.pty_id) {
        state.detail.order_info.pty_id = data.pty_id
      }
      if (data.delivery_total) {
        state.detail.order_info.delivery_total = data.delivery_total
      }
      if (data.dhy_id) {
        state.detail.order_info.dhy_id = data.dhy_id
      }
    },
    UPDATE_CONTACT(state, data) {
      state.detail.order_info.email = data.email
      state.detail.order_info.ahe_telephone_number = data.ahe_telephone_number
    },
    UPDATE_COMPANY(state, data) {
      state.detail.order_info.ahe_company_name = data.ahe_company_name
      state.detail.order_info.ahe_vatin = data.ahe_vatin
      state.detail.order_info.ahe_tin = data.ahe_tin
    },
    UPDATE_ORDER_ITEM(state, { id, item, quantity }) {
      const oldNote = state.detail.items.find(x => x.oim_id === item.oim_id)
      item.quantity = quantity
      Object.assign(oldNote, item)
    },
    DELETE_NOTE(state, item) {
      state.detail.notes.splice(state.detail.notes.indexOf(item), 1)
    },
    DELETE_ITEM(state, items) {
      for (let i = 0; i < state.detail.items.length; i++) {
        if (items.includes(state.detail.items[i].oim_id)) {
          state.detail.items.splice(i, 1)
          i = i - 1
        }
      }
    },
    DELETE(state, items) {
      for (let i = 0; i < state.items.length; i++) {
        if (items.includes(state.items[i].odr_id)) {
          state.items.splice(i, 1)
          i = i - 1
        }
      }
    },
    UPDATE_STATUS(state, payload) {
      for (let i = 0; i < state.items.length; i++) {
        if (payload.items.includes(state.items[i].odr_id)) {
          state.items[i].status = payload.status
        }
      }
      if (state.detail !== null && payload.items.includes(state.detail.order_info.odr_id)) {
        state.detail.order_info.status = payload.status
      }
    },
    UPDATE_ADDRESS(state, payload) {
      if (payload.type === 'big') {
        state.detail.order_info.big_city = payload.data.ahe_city
        state.detail.order_info.big_first_name = payload.data.ahe_first_name
        state.detail.order_info.big_last_name = payload.data.ahe_last_name
        state.detail.order_info.big_street = payload.data.ahe_street
        state.detail.order_info.big_zip = payload.data.ahe_zip
        state.detail.order_info.big_cty_id = payload.data.cty_id
        return
      }
      state.detail.order_info.dly_city = payload.data.ahe_city
      state.detail.order_info.dly_first_name = payload.data.ahe_first_name
      state.detail.order_info.dly_last_name = payload.data.ahe_last_name
      state.detail.order_info.dly_street = payload.data.ahe_street
      state.detail.order_info.dly_zip = payload.data.ahe_zip
      state.detail.order_info.dly_cty_id = payload.data.cty_id
    },
  },
  actions: {
    getList({ commit }) {
      return new Promise((resolve, reject) => {
        $axios.get('/order', {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(response => {
          commit('SET_CURRENT', response.data)
          resolve(response)
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    getOne({ commit }, id) {
      return new Promise((resolve, reject) => {
        $axios.get('/order/' + id, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(response => {
          commit('SET_CURRENT_DETAIL', response.data)
          resolve(response)
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    putDeliveryPayment({ commit }, { id, data }) {
      return new Promise((resolve, reject) => {
        $axios.put('/order/' + id + '/delivery-payment', data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          commit('UPDATE_DELIVERY_PAYMENT', data)
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Upravení proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    putContact({ commit }, { id, data }) {
      return new Promise((resolve, reject) => {
        $axios.put('/order/' + id + '/contact', data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          commit('UPDATE_CONTACT', data)
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Upravení proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    putCompany({ commit }, { id, data }) {
      return new Promise((resolve, reject) => {
        $axios.put('/order/' + id + '/company', data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          commit('UPDATE_COMPANY', data)
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Upravení proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    status({ commit }, object) {
      return new Promise((resolve, reject) => {
        $axios.patch('/order?status=' + object.status + '&sendemail=' + object.sent, {
          data: object.items.map(x => {
            return { odr_id: x }
          }),
        }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          commit('UPDATE_STATUS', { items: object.items, status: object.status })
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Upravení stavu proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    delete({ commit }, items) {
      return new Promise((resolve, reject) => {
        $axios.delete('/order', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
          data: {
            data: items.map(x => {
              return { odr_id: x }
            }),
          },
        }).then(() => {
          commit('DELETE', items)
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Odstranění proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    postItem({ commit }, { id, item }) {
      return new Promise((resolve, reject) => {
        $axios.post('/order/' + id + '/item', { data: item }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then((data) => {
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Vytvoření proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    putItemQuantity({ commit }, { id, item, quantity }) {
      return new Promise((resolve, reject) => {
        $axios.put('/order/' + id + '/item/' + item.oim_id, {
          data: {
            oim_quantity: quantity,
          },
        }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        },
        ).then(() => {
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Upravení proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    deleteItem({ commit }, { id, item }) {
      return new Promise((resolve, reject) => {
        $axios.delete('/order/' + id + '/item/' + item, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Odstranění proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    postNote({ commit }, items) {
      return new Promise((resolve, reject) => {
        $axios.post('/order/note', { data: items }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then((data) => {
          commit('ADD_NOTE', { id: data.data, item: items })
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Vytvoření proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    putNote({ commit }, { id, item }) {
      return new Promise((resolve, reject) => {
        $axios.put('/order/note/' + id, { data: item }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          commit('UPDATE_NOTE', { id: id, item: item })
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Upravení proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    deleteNote({ commit }, item) {
      return new Promise((resolve, reject) => {
        $axios.delete('/order/note/' + item.one_id, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          commit('DELETE_NOTE', item)
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Odstranění proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
  },
  getters: {
    allItems: state => state.items,
    filterItems: (state) => (searchText = '') => {
      if (searchText.trim().length > 0) {
        return filter.methods.filterItems(state.items, filteredKeys, searchText)
      }
      return state.items
    },
    getDetail: (state) => {
      return state.detail
    },
    getStatuses: (state) => {
      return state.statuses
    },
  },
}
